var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',[_c('f7-navbar',{attrs:{"title":"Area 52","back-link":"Back"}})],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }